import { Observable } from "rxjs";
import HttpClient from "@/api/HttpClient";
import { APIHosts, ApiReduxHelpers } from "@/services/reduxHelpers";

export type DrawingDto = {
  id: number;
  sheetPath: string;
  title: string;
  sheetNum: string;
  type: string;
  currentVersion: string;
  latestVersion: number;
  tag: string;
  favorite: string;
  installingCompany?: string | null;
  installingCompanyId?: number | null;
  projectPermit?: string | null;
  hidden: string;
  guid: string;
  publishedDate: string;
  structureName: string;
};

class DrawingsService extends ApiReduxHelpers {
  constructor() {
    super();
  }

  ApiHost = APIHosts.App;

  getAllFileDrawing(projectId: number): Observable<DrawingDto[]> {
    return HttpClient.get<DrawingDto[]>(
      `${this.getHost(this.ApiHost)}/api/sheets/list?projectId=${projectId}`
    );
  }
    getDrawingSheetJson(sheetPath: string) {
    const encodedPath = encodeURIComponent(sheetPath);
    const url = `${this.getHost(this.ApiHost)}/api/Download/download-sheet-json?sheetPath=${encodedPath}`;
    return fetch(url).then((res) => res.json());
  }

}



const drawingsService = new DrawingsService();
export default drawingsService;


